import { React, useState } from "react";
import Navbar from "../components/Navbar";
import { Link, useNavigate } from "react-router-dom";
import { BASE_URL } from "../helper";

export default function Login() {
	const [credentials, setCredentials] = useState({
		email: "",
		password: "",
	});
	let navigate = useNavigate();
	const handleSubmit = async (e) => {
		e.preventDefault();
		const respone = await fetch(`${BASE_URL}/api/loginuser`, {
			method: "POST",
			headers: {
				"Content-Type": "application/json",
			},
			body: JSON.stringify({
				email: credentials.email,
				password: credentials.password,
			}),
		});

		const json = await respone.json();
		console.log(json);

		if (!json.success) {
			alert("Enter valid credentials");
		}
		if (json.success) {
			localStorage.setItem("userEmail", credentials.email);
			localStorage.setItem("authToken", json.authToken);
			console.log(localStorage.getItem("authToken"));
			navigate("/");
		}
	};

	const handleChange = (e) => {
		setCredentials({ ...credentials, [e.target.name]: e.target.value });
	};

	return (
		<div
			style={{
				backgroundImage:
					'url("https://images.pexels.com/photos/326278/pexels-photo-326278.jpeg?auto=compress&cs=tinysrgb&w=1260&h=750&dpr=1")',
				height: "100vh",
				backgroundSize: "cover",
			}}
		>
			<div>
				<Navbar />
			</div>
			<div className="container">
				<form
					className="w-50 m-auto mt-5 border bg-dark border-success rounded"
					onSubmit={handleSubmit}
				>
					<div className="m-3">
						<label htmlFor="exampleInputEmail1" className="form-label">
							Email address
						</label>
						<input
							type="email"
							className="form-control"
							name="email"
							value={credentials.email}
							onChange={handleChange}
							aria-describedby="emailHelp"
						/>
						<div id="emailHelp" className="form-text">
							We'll never share your email with anyone.
						</div>
					</div>
					<div className="m-3">
						<label htmlFor="exampleInputPassword1" className="form-label">
							Password
						</label>
						<input
							type="password"
							className="form-control"
							value={credentials.password}
							onChange={handleChange}
							name="password"
						/>
					</div>
					<button type="submit" className="m-3 btn btn-success">
						Submit
					</button>
					<Link to="/createuser" className="m-3 mx-1 btn btn-danger">
						New User
					</Link>
				</form>
			</div>
		</div>
	);
}
